import AdminService from "@/services/adminService";

export default {
    namespaced: true,

    state: () => ({
        adminService: new AdminService(),

        tablesInfo: null,

        users: [],
        groups: [],
        groupsAndUsers: [],
        invitations: [],

        authors: [],
        citations: [],
        hobbies: [],
        sports: [],
        food: [],
        desserts: []
    }),

    getters: {

    },

    mutations: {
        setTablesInfo(state, newValue) {
            state.tablesInfo = newValue;
        },

        setUsers(state, newValue) {
            state.users = newValue;
        },

        setGroups(state, newValue) {
            state.groups = newValue;
        },

        setGroupsAndUsers(state, newValue) {
            state.groupsAndUsers = newValue;
        },

        setInvitations(state, newValue) {
            state.invitations = newValue;
        },

        setAuthors(state, newValue) {
            state.authors = newValue;
        },

        setCitations(state, newValue) {
            state.citations = newValue;
        },

        setHobbies(state, newValue) {
            state.hobbies = newValue;
        },

        setSports(state, newValue) {
            state.sports = newValue;
        },

        setFood(state, newValue) {
            state.food = newValue;
        },

        setDessert(state, newValue) {
            state.desserts = newValue;
        }
    },

    actions: {
        loadTablesInfo({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getTablesInfo()
                .then(response => {
                    commit("setTablesInfo", response.data);

                    // Для тестов
                    //commit("success", "Странно, что все ок", { root: true });
                    //commit("warning", "Последнее пердупреждение", { root: true });
                    //commit("error", "Страшная ошибка", { root: true });
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        loadUsers({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getAllUsers()
                .then(response => {
                    commit("setUsers", response.data);
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        loadGroups({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getAllGroups()
                .then(response => {
                    commit("setGroups", response.data);
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        loadGroupsAndUsers({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getAllGroupsAndUsers()
                .then(response => {
                    commit("setGroupsAndUsers", response.data);
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        loadInvitations({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getAllInvitations()
                .then(response => {
                    commit("setInvitations", response.data);
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        loadAuthors({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getAllAuthors()
                .then(response => {
                    commit("setAuthors", response.data);
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        upsertAuthor({ state, commit }, author) {
            return state.adminService.upsertAuthor(author)
                .then(response => {
                    if (response.data && !response.data.isSuccess) {
                        commit("warning", response.data.message, { root: true });
                        return;
                    }
                })
                .catch(error => commit("error", error.message, { root: true }));
        },

        loadCitations({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getAllCitations()
                .then(response => {
                    commit("setCitations", response.data);
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        upsertCitation({ state, commit }, citation) {
            return state.adminService.upsertCitation(citation)
                .then(response => {
                    if (response.data && !response.data.isSuccess) {
                        commit("warning", response.data.message, { root: true });
                        return;
                    }
                })
                .catch(error => commit("error", error.message, { root: true }));
        },

        loadHobbies({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getAllHobbies()
                .then(response => {
                    commit("setHobbies", response.data);
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        upsertHobby({ state, commit }, hobby) {
            return state.adminService.upsertHobby(hobby)
                .then(response => {
                    if (response.data && !response.data.isSuccess) {
                        commit("warning", response.data.message, { root: true });
                        return;
                    }
                })
                .catch(error => commit("error", error.message, { root: true }));
        },

        loadSports({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getAllSports()
                .then(response => {
                    commit("setSports", response.data);
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        upsertSport({ state, commit }, sport) {
            return state.adminService.upsertSport(sport)
                .then(response => {
                    if (response.data && !response.data.isSuccess) {
                        commit("warning", response.data.message, { root: true });
                        return;
                    }
                })
                .catch(error => commit("error", error.message, { root: true }));
        },

        loadFood({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getAllFood()
                .then(response => {
                    commit("setFood", response.data);
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        upsertFood({ state, commit }, food) {
            return state.adminService.upsertFood(food)
                .then(response => {
                    if (response.data && !response.data.isSuccess) {
                        commit("warning", response.data.message, { root: true });
                        return;
                    }
                })
                .catch(error => commit("error", error.message, { root: true }));
        },

        loadDesserts({ state, commit }) {
            commit("startLoading", null, { root: true });

            return state.adminService.getAllDesserts()
                .then(response => {
                    commit("setDessert", response.data);
                })
                .catch(error => commit("error", error.message, { root: true }))
                .finally(() => commit("stopLoading", null, { root: true }));
        },

        upsertDessert({ state, commit }, dessert) {
            return state.adminService.upsertDessert(dessert)
                .then(response => {
                    if (response.data && !response.data.isSuccess) {
                        commit("warning", response.data.message, { root: true });
                        return;
                    }
                })
                .catch(error => commit("error", error.message, { root: true }));
        }
    }
};
